/* Fetch theme — collection filtering & sorting via Section Rendering API */
(function () {
  'use strict';
  const F = window.Fetch;

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.forms = Array.from(this.querySelectorAll('form[data-facets-form]'));
      this.forms.forEach(form => {
        form.addEventListener('change', F.debounce(e => this.onChange(form, e), 300));
        form.addEventListener('submit', e => { e.preventDefault(); this.onChange(form); });
      });
      this.addEventListener('click', e => {
        const remove = e.target.closest('[data-facet-remove]');
        if (remove) { e.preventDefault(); this.load(remove.href, true); }
        const clear = e.target.closest('[data-facet-clear]');
        if (clear) { e.preventDefault(); this.load(clear.href, true); }
      });
      window.addEventListener('popstate', () => this.load(window.location.href, false));
    }
    onChange(form, e) {
      // Merge all forms (desktop sidebar + mobile drawer + sort) into one query
      const params = new URLSearchParams(new FormData(form));
      // Keep sort_by if it exists in another form
      if (!params.has('sort_by')) {
        const other = this.querySelector('[name="sort_by"]');
        if (other) params.set('sort_by', other.value);
      }
      // Remove empty price fields
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach(k => { if (params.has(k) && !params.get(k)) params.delete(k); });
      params.delete('page');
      const url = `${window.location.pathname}?${params.toString()}`;
      this.load(url, true);
    }
    async load(url, push) {
      const container = document.getElementById(`ProductGridContainer-${this.sectionId}`);
      container && container.classList.add('collection-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      try {
        const res = await fetch(u.toString());
        const html = await res.text();
        const doc = F.parseHTML(html);
        const swap = id => {
          const fresh = doc.getElementById(id);
          const cur = document.getElementById(id);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        };
        swap(`ProductGridContainer-${this.sectionId}`);
        swap(`FacetsDesktop-${this.sectionId}`);
        swap(`FacetsMobile-${this.sectionId}`);
        swap(`ActiveFacets-${this.sectionId}`);
        swap(`ProductCount-${this.sectionId}`);
        swap(`ProductCountMobile-${this.sectionId}`);
        const sortFresh = doc.querySelector('[name="sort_by"]');
        if (sortFresh) document.querySelectorAll('[name="sort_by"]').forEach(s => s.value = sortFresh.value);
        if (push) window.history.pushState({}, '', url);
        this.forms = Array.from(this.querySelectorAll('form[data-facets-form]'));
      } catch (e) {
        window.location.href = url;
      } finally {
        container && container.classList.remove('collection-loading');
      }
    }
  }
  customElements.define('facet-filters', FacetFilters);

  // Pagination via AJAX (keeps filters, scrolls to top of grid)
  document.addEventListener('click', e => {
    const link = e.target.closest('.pagination a');
    const facets = document.querySelector('facet-filters');
    if (!link || !facets) return;
    e.preventDefault();
    facets.load(link.href, true).then(() => {
      const grid = document.getElementById(`ProductGridContainer-${facets.sectionId}`);
      grid && grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
